import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSsosKey } from '../../utils/keys';
export const useSsos = (options) => {
    const { variables, useQueryOptions } = options || {};
    const { client } = useTribeClient();
    const ssosKey = getSsosKey();
    return useQuery(ssosKey, () => client.auth.ssos(variables), useQueryOptions);
};
//# sourceMappingURL=useSsos.js.map